import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ffdc7b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-profile-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "73",
    height: "21",
    viewBox: "0 0 73 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M34.2165 0.0771484L27.5265 20.711H22.8789L16.0625 0.0771484H20.372L24.1464 12.3592C24.2215 12.5711 24.3248 12.9661 24.4563 13.5441C24.6065 14.1028 24.7567 14.7 24.9069 15.3358C25.0571 15.9523 25.1604 16.4725 25.2168 16.8964C25.2731 16.4725 25.367 15.9523 25.4984 15.3358C25.6487 14.7 25.7989 14.1028 25.9491 13.5441C26.0993 12.9661 26.2026 12.5711 26.2589 12.3592L29.9461 0.0771484H34.2165Z",
      fill: "#3B97DE"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M37.0015 5.22117V20.711H34.5229V5.22117H37.0015Z",
      fill: "#3B97DE"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M45.3619 4.93218C46.6575 4.93218 47.7654 5.22117 48.6856 5.79915C49.6245 6.37713 50.338 7.19593 50.8262 8.25556C51.3332 9.29593 51.5867 10.5193 51.5867 11.9257V13.4574H41.2495C41.287 15.2106 41.7189 16.5496 42.5452 17.4743C43.3902 18.3798 44.5638 18.8326 46.066 18.8326C47.0237 18.8326 47.8687 18.7459 48.601 18.5725C49.3522 18.3798 50.1221 18.1101 50.9107 17.7633V19.9885C50.1409 20.3353 49.3803 20.5858 48.6292 20.7399C47.8781 20.9133 46.9861 21 45.9534 21C44.5262 21 43.2587 20.7014 42.1508 20.1041C41.0617 19.5069 40.2073 18.6207 39.5876 17.4454C38.9867 16.2509 38.6863 14.7964 38.6863 13.0817C38.6863 11.3863 38.9586 9.9317 39.5031 8.71795C40.0665 7.50419 40.8458 6.56979 41.841 5.91474C42.855 5.2597 44.0286 4.93218 45.3619 4.93218ZM45.3337 7.0129C44.1507 7.0129 43.2118 7.40786 42.517 8.19776C41.841 8.9684 41.4373 10.0473 41.3058 11.4344H48.9954C48.9766 10.1244 48.6762 9.06473 48.0941 8.25556C47.5119 7.42712 46.5918 7.0129 45.3337 7.0129Z",
      fill: "#3B97DE"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M63.3114 11.9546C63.0673 11.1647 62.8513 10.3941 62.6636 9.64271C62.4945 8.87207 62.3631 8.27483 62.2692 7.85098H62.1565C62.0814 8.27483 61.9594 8.87207 61.7904 9.64271C61.6214 10.3941 61.4054 11.1744 61.1425 11.9835L58.4385 20.6821H55.6218L51.4813 5.19227H54.0445L56.1288 13.4574C56.3354 14.2858 56.5325 15.1239 56.7203 15.9716C56.9081 16.8193 57.0396 17.5225 57.1147 18.0812H57.2273C57.3024 17.7537 57.3869 17.3491 57.4808 16.8675C57.5935 16.3858 57.7156 15.8849 57.847 15.3647C57.9785 14.8253 58.1099 14.3436 58.2413 13.9198L60.9172 5.19227H63.6212L66.2126 13.9198C66.4191 14.5748 66.6163 15.2876 66.8041 16.0583C67.0106 16.8289 67.1515 17.4936 67.2266 18.0523H67.3393C67.3956 17.5707 67.5177 16.906 67.7054 16.0583C67.912 15.2106 68.1279 14.3436 68.3533 13.4574L70.4658 5.19227H73.0008L68.8039 20.6821H65.9027L63.3114 11.9546Z",
      fill: "#3B97DE"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16.6748 10.1915C16.6748 13.6787 15.7078 16.3085 13.7736 18.081C11.8583 19.8342 9.16365 20.7108 5.68973 20.7108H0V0.0769043H6.3094C8.41253 0.0769043 10.234 0.462224 11.7738 1.23286C13.3324 2.0035 14.5341 3.1402 15.3792 4.64294C16.2429 6.12642 16.6748 7.97596 16.6748 10.1915ZM12.2526 10.3071C12.2526 8.01449 11.7644 6.33835 10.7879 5.27872C9.81149 4.19983 8.39375 3.66038 6.53473 3.66038H4.25321V17.0984H6.08406C10.1964 17.0984 12.2526 14.8347 12.2526 10.3071Z",
      fill: "#001965"
    }),
    /*#__PURE__*/_createElementVNode("ellipse", {
      cx: "35.8595",
      cy: "1.44495",
      rx: "1.40835",
      ry: "1.44495",
      fill: "#28A7DD"
    })
  ])
], -1))
const _hoisted_3 = { class: "version" }
const _hoisted_4 = {
  key: 0,
  class: "build"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_menu, {
        "menu-id": "homemenu",
        "content-id": "main-content",
        type: "overlay",
        "max-edge-start": "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.user?.name), 1)
              ]),
              _createVNode(_component_ion_list, { class: "menu-items" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (!item.hidden)
                        ? (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                            "auto-hide": "false",
                            key: item.name
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                button: "",
                                "router-direction": "forward",
                                "router-link": item.path,
                                lines: "none",
                                detail: "false",
                                disabled: item.disabled
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: item.icon
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["router-link", "disabled"])
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: "app-version",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDeveloperMenuInProduction && _ctx.toggleDeveloperMenuInProduction(...args)))
              }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, "Version " + _toDisplayString(_ctx.version), 1),
                (_ctx.showBuildInfo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.build), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_router_outlet, { id: "main-content" })
    ]),
    _: 1
  }))
}